/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ExportUnifiedDashboardsExportGet$Params {
  /**
   * ID проекта
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;
  from?: string | null;
  to?: string | null;
  d9_granularity?: 'month' | 'quarter' | 'year';
  d4_granularity?: 'month' | 'year';
  d8_granularity?: 'month' | 'year';
}

export function exportUnifiedDashboardsExportGet(
  http: HttpClient,
  rootUrl: string,
  params: ExportUnifiedDashboardsExportGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, exportUnifiedDashboardsExportGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('d9_granularity', params.d9_granularity, {});
    rb.query('d4_granularity', params.d4_granularity, {});
    rb.query('d8_granularity', params.d8_granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<any>;
    }),
  );
}

exportUnifiedDashboardsExportGet.PATH = '/dashboards/export';
